﻿/**
* DevExpress Analytics (query-builder\widgets\masterdetaileditor\_masterDetailRelationSurface.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var _keyColumnSurface_1 = require("./_keyColumnSurface");
var MasterDetailRelationSurface = (function () {
    function MasterDetailRelationSurface(relation, parent) {
        var _this = this;
        this.isEditable = ko.observable(false);
        this.relationName = relation.name;
        this.keyColumns = ko.pureComputed(function () {
            return relation.keyColumns().map(function (item) {
                return {
                    master: new _keyColumnSurface_1.KeyColumnSurface(item.masterColumn, relation.masterQuery(), true),
                    detail: new _keyColumnSurface_1.KeyColumnSurface(item.detailColumn, relation.detailQuery(), false)
                };
            });
        });
        this.create = function () {
            relation.createKeyColumn();
        };
        this.remove = function (data) {
            relation.keyColumns.remove(function (item) { return item.masterColumn === data.master.column && item.detailColumn === data.detail.column; });
            if (relation.keyColumns().length === 0)
                parent.remove(_this);
        };
    }
    return MasterDetailRelationSurface;
}());
exports.MasterDetailRelationSurface = MasterDetailRelationSurface;
